import { StockDistributionResponse, StockDistributionTypes } from '@interfaces'
import { api } from '@utils/api/api'

export const getStocksByType = (
  groupingType: StockDistributionTypes,
): Promise<StockDistributionResponse> => {
  return api.get(`/api/v1/portfolio/grouped/${groupingType}`)
}
